module.exports = __webpack_public_path__ + "static/img/profile.03af0e1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/profile.jpg
// module id = F8+k
// module chunks = 0